import { DEFECT_ESTIMATED_COSTS } from "@idwal/idwal-utilities/lib/types/DefectEstimatedCosts";
import { Defect } from "../../types/defect";

export const CustomEstimateCostBody = (defect: Defect) => {
    const estimateDefectCost = DEFECT_ESTIMATED_COSTS.find((cost) => cost.id === defect.estimateDefectCostRangeId);

    if (
        !defect.estimateDefectCost ||
        !estimateDefectCost ||
        estimateDefectCost.label !== "custom"
    ) {
        return null;
    }

    return <div>{`$${defect.estimateDefectCost.toFixed(2)}`}</div>
};
